import React, { useState, useEffect } from "react";
import { Formik, useFormikContext } from "formik";
import _ from "lodash";
import { withRouter } from "react-router";
import {
  DatePicker,
  AutoComplete,
  Radio,
  Input,
  Button,
  Select,
  Row,
  Col,
  Spin,
} from "antd";
import moment from "moment";
import * as Yup from "yup";
import fire from "./fire";
import "antd/dist/antd.css";
import ConfirmationPopup from "./ConfirmationPopup";
import { getEntryAndTargetPricesFromValues } from "./helper/helper";
import { FormDatePicker } from "./formComponents/FormDatePicker";
import { getValidDate,setValidTill } from "./helper/helper";
// import functions from "firebase/functions";
const { Option } = Select;

const errorStyle = {
  color: "red",
};

const adviseContainerStyle = {
  display: "flex",
  background: "rgba(255,255,255)",
  margin: "auto",
  padding: 10,
  border: "2px black",
  borderRadius: 5,
  boxShadow: "4px 4px 6px 0px rgba(50, 50, 50, 0.3)",
  maxWidth: 600,
  flexDirection: "column",
};

const AddAdvise = (props) => {
  const [symbolDB, setSymbolDB] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [enableCustomDate, setCustomDate] = useState(false);
  const [userData, setUserData] = useState();
  const [hideDuration, setHideDuration] = useState();
  const [stagingStock, setStagingStock] = useState();
  useEffect(async () => {
    checkLogin();
    await getUserSnapshot();
  }, []);

  const adviseSchema = Yup.object().shape({
    symbol: Yup.string().required("required"),
    entryPriceFrom: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    entryPriceTo: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    targetPriceFrom: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    targetPriceTo: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    slPrice: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    advisoryType: Yup.string().required("required"),
    comments: Yup.string().required("required"),
    positionType: Yup.string().required("required"),
    quickTradeType: Yup.string().required("required"),
    expiry: Yup.string()
      .test("quickTradeTypeTest", "Expiry type is required", function (expiry) {
        if (
          this.options.parent.quickTradeType === "options" ||
          this.options.parent.quickTradeType === "futures"
        ) {
          if (expiry === "na") {
            return false;
          }
        }
        return true;
      })
      .required("required"),
  });

  const AutoUpdateForSellOrder = () => {
    // Grab values and submitForm from context
    const { values, setFieldValue } = useFormikContext();
    useEffect(() => {
      // Submit the form imperatively as an effect as soon as form values.token are 6 digits long
      if (
        values.positionType === "SELL" &&
        values.quickTradeType === "equity"
      ) {
        setHideDuration(true);
        setFieldValue("advisoryType", "INTRADAY");
        setFieldValue("validTill", setValidTill("INTRADAY"));
      } else {
        // if (values.advisoryType === "INTRADAY") setValidTill("INTRADAY");
        // setFieldValue("advisoryType", "");
        // setFieldValue("validTill", "");
        setHideDuration(false);
      }
    }, [values.quickTradeType,values.positionType]);
    return null;
  };

  const getUserSnapshot = async () => {
    try {
      const db = fire.firestore();
      const id =
        (await fire.auth().currentUser?.uid) || props.location.state.uid;
      const userSnapshot = await db.collection("users").doc(id).get();
      let userData = await userSnapshot.data();
      userData.uid = id;
      setUserData(userData);
    } catch (error) {
      console.log(error);
    }
  };

  const checkLogin = () => {
    fire.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
      } else {
        // No user is signed in.
        props.history.push("/phone-login");
      }
    });
  };

  const backToDashboard = () => {
    props.history.push("/");
  };

  const onSearch = async (searchText) => {
    const api = fire.functions().httpsCallable("symbolSearch");
    api({ keyword: searchText })
      .then(function (result) {
        const tempSymbolDb = result.data.data.map((item) => item.symbol);
        setSymbolDB(tempSymbolDb);
      })
      .catch((error) => console.log(error));
  };
  const stagingOnSearch = async (searchKey) => {
    try {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      let raw = JSON.stringify({
        data: {
          keyword: searchKey,
        },
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let request = await fetch(
        "https://us-central1-marketfeed-news.cloudfunctions.net/symbolSearchHttp",
        requestOptions
      );
      let response = await request.json();
      const tempSymbolDb = response.result.data.map((item) => item.symbol);
      setSymbolDB(tempSymbolDb);
    } catch (error) {
      const tempSymbolDb = ["error"];
      setSymbolDB(tempSymbolDb);
    }
  };
  // debouncing function for onsearch of symbols from api
  const debouncedSearch = _.debounce(onSearch, 500);

  const stagingDebouncedSearch = _.debounce(stagingOnSearch, 500);
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current < moment().add(3, "M").startOf("day");
  };
  const setDefaultDate = (setFieldValue) => {
    // Can not select days before today and today
    let time = "15:30";
    let date = new Date(moment().add(3, "M").startOf(time));
    setFieldValue("validTill", date.getTime());
    return moment().add(3, "M").startOf(time);
  };
 
  const add = (values, setSubmitting, setFieldValue, setErrors) => {
    setIsLoading(true);
    let db = fire.firestore();
    let commentObject = {};
    const currentDate = new Date().getTime();
    let { advisoryId, name, uid } = fire.auth().currentUser;
    if (fire.auth().currentUser.uid === undefined) uid = "";
    if (fire.auth().currentUser.name === undefined) name = "";
    if (fire.auth().currentUser.advisoryId === undefined) advisoryId = "";
    if (values.comments) {
      commentObject.message = values.comments;
      commentObject.timestamp = currentDate;
      commentObject.status = "Waiting For Activation";
    }
    let history = values;
    history.timestamp = currentDate;
    values = getEntryAndTargetPricesFromValues(values);
    values = {
      ...values,
      createdBy: {
        name: userData.name,
        uid: userData.uid,
        profileImageUrl: userData.profileImage,
        advisorId: userData.advisorId,
      },
      createdAt: currentDate,
      updatedAt: currentDate,
      status: "Waiting For Activation",
      comments: [commentObject],
      history: [history],
      advisoryCategory: "sebi-feed",
    };
    db.collection("advises")
      .add(values)
      .then(function (docRef) {
        setTimeout(() => {
          setIsLoading(false);
          setSubmitting(false);
          props.history.push("/");
        }, 2000);
      })
      .catch(function (error) {
        console.error("Error adding document: ", error);
      });
  };
  const handleQuickTradeExpiryChange = (
    event,
    values,
    handleChange,
    setFieldValue
  ) => {
    handleChange(event);
    if (event.target.value === "equity") {
      setFieldValue("expiry", "na");
    }
    if (event.target.value === "futures") {
      setFieldValue("expiry", "month");
    }
  };
  return isLoading ? (
    <div className="adviseContainer">
      <Spin />
    </div>
  ) : (
    <section>
      <div className="adviseContainer" style={adviseContainerStyle}>
        <div
          style={{
            display: "flex",
            padding: 5,
            justifyContent: "space-between",
          }}
        >
          <Button
            type="ghost"
            shape="round"
            icon="left"
            onClick={backToDashboard}
          />
          <h2>
            <span>
              add
              <span style={{ fontWeight: 800, marginRight: 100 }}>advise.</span>
            </span>
          </h2>
        </div>
        <Formik
          initialValues={{
            symbol: "",
            entryPriceFrom: "",
            entryPriceTo: "",
            targetPriceFrom: "",
            targetPriceTo: "",
            slPrice: "",
            advisoryType: "",
            positionType: "",
            comments: "",
            validTill: "",
            quickTradeType: "equity",
            expiry: "na",
          }}
          validationSchema={adviseSchema}
          onSubmit={(values, { setSubmitting, setFieldValue, setErrors }) => {
            setSubmitting(true);
            add(values, setSubmitting, setFieldValue, setErrors);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <Row>
                <Col span={24}>
                  <label>Search Symbol</label>
                  {window.location.href ==
                  "https://marketfeed-news.web.app/add-advise" ? (
                    <AutoComplete
                      className="formInput"
                      dataSource={symbolDB}
                      onSelect={(value) => {
                        setFieldValue("symbol", value);
                      }}
                      onSearch={debouncedSearch}
                      placeholder="Search Format symbol yymm dd. strike ce/pe. Eg- nifty 2011 26 13200 ce"
                    />
                  ) : (
                    <AutoComplete
                      className="formInput"
                      dataSource={symbolDB}
                      onSelect={(value) => {
                        setFieldValue("symbol", value);
                      }}
                      onSearch={stagingDebouncedSearch}
                      placeholder="Search Format symbol yymm dd. strike ce/pe. Eg- nifty 2011 26 13200 ce"
                    />
                  )}
                  <span style={errorStyle}>
                    {errors.symbol && touched.symbol && errors.symbol}
                  </span>
                </Col>
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <label>Position Type</label>
                  <div>
                    <Radio.Group
                      defaultValue="BUY"
                      buttonStyle="solid"
                      name="positionType"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.positionType}
                    >
                      <Radio.Button value="BUY">Buy</Radio.Button>
                      <Radio.Button value="SELL">Sell</Radio.Button>
                    </Radio.Group>
                  </div>
                  <span style={errorStyle}>
                    {errors.positionType &&
                      touched.positionType &&
                      errors.positionType}
                  </span>
                </Col>
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <label>Trade Type</label>
                  <div>
                    <Radio.Group
                      defaultValue="equity"
                      buttonStyle="solid"
                      name="quickTradeType"
                      onChange={(event) => {
                        handleQuickTradeExpiryChange(
                          event,
                          values,
                          handleChange,
                          setFieldValue
                        );
                      }}
                      onBlur={handleBlur}
                      value={values.quickTradeType}
                    >
                      <Radio.Button value="equity">Equity</Radio.Button>
                      <Radio.Button value="options">Options</Radio.Button>
                      <Radio.Button value="futures">Futures</Radio.Button>
                    </Radio.Group>
                  </div>
                  <span style={errorStyle}>
                    {errors.quickTradeType &&
                      touched.quickTradeType &&
                      errors.quickTradeType}
                  </span>
                  <AutoUpdateForSellOrder />
                </Col>
                {values.quickTradeType === "options"  ? (
                  <Col style={{ margin: "5px 0px" }} span={24}>
                    <label>Expiry Type</label>
                    <div>
                      <Radio.Group
                        buttonStyle="solid"
                        name="expiry"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.expiry}
                      >
                        <Radio.Button value="month">Month</Radio.Button>
                        <Radio.Button value="week">Week</Radio.Button>
                      </Radio.Group>
                    </div>
                    <span style={errorStyle}>
                      {errors.expiry && touched.expiry && errors.expiry}
                    </span>
                  </Col>
                ) : null}
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <label>Entry Price</label>
                </Col>
                <Col style={{ margin: "auto" }} span={12}>
                  <Input
                    className="formInput"
                    name="entryPriceFrom"
                    type="number"
                    min="0"
                    placeholder="Minimum"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.entryPriceFrom}
                    step="any"
                  />
                  <span style={errorStyle}>
                    {errors.entryPriceFrom &&
                      touched.entryPriceFrom &&
                      errors.entryPriceFrom}
                  </span>
                </Col>
                <Col style={{ margin: "auto" }} span={12}>
                  <Input
                    className="formInput"
                    name="entryPriceTo"
                    type="number"
                    min="0"
                    placeholder="Maximum"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.entryPriceTo}
                    step="any"
                  />
                  <span style={errorStyle}>
                    {errors.entryPriceTo &&
                      touched.entryPriceTo &&
                      errors.entryPriceTo}
                  </span>
                </Col>
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <label>Target Price</label>
                </Col>
                <Col style={{ margin: "auto" }} span={12}>
                  <Input
                    className="formInput"
                    name="targetPriceFrom"
                    type="number"
                    min="0"
                    placeholder="Minimum"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.targetPriceFrom}
                    step="any"
                  />
                  <span style={errorStyle}>
                    {errors.targetPriceFrom &&
                      touched.targetPriceFrom &&
                      errors.targetPriceFrom}
                  </span>
                </Col>
                <Col style={{ margin: "auto" }} span={12}>
                  <Input
                    className="formInput"
                    name="targetPriceTo"
                    type="number"
                    min="0"
                    placeholder="Maximum"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.targetPriceTo}
                    step="any"
                  />
                  <span style={errorStyle}>
                    {errors.targetPriceTo &&
                      touched.targetPriceTo &&
                      errors.targetPriceTo}
                  </span>
                </Col>
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <label>Stop Loss Price</label>
                  <Input
                    className="formInput"
                    name="slPrice"
                    type="number"
                    min="0"
                    placeholder="Stop Loss Price"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.slPrice}
                    step="any"
                  />
                  <span style={errorStyle}>
                    {errors.slPrice && touched.slPrice && errors.slPrice}
                  </span>
                </Col>
                {!hideDuration ? (
                  <Col style={{ margin: "5px 0px", padding: "5" }} span={24}>
                    <label>Type/Duration</label>
                    <Select
                      className="formInput"
                      name="advisoryType"
                      onChange={(value) => {
                        setFieldValue("advisoryType", value);
                        if (value !== "More Than 3 Months")
                          setFieldValue("validTill", setValidTill(value));
                        else {
                          setCustomDate(true);
                          setFieldValue("validTill");
                        }
                      }}
                      value={values.advisoryType}
                    >
                      <Option value="INTRADAY">INTRADAY</Option>
                      <Option value="BTST">BTST</Option>
                      <Option value="STBT">STBT</Option>
                      <Option value="2-3 Days">2-3 Days</Option>
                      <Option value="1-Week">1-Week</Option>
                      <Option value="2-Weeks">2-Weeks</Option>
                      <Option value="3-Weeks">3-Weeks</Option>
                      <Option value="1-Month">1-Month</Option>
                      <Option value="3-Months">3-Months</Option>
                      <Option value="More Than 3 Months">
                        More Than 3 Months
                      </Option>
                    </Select>
                    <span style={errorStyle}>
                      {errors.advisoryType &&
                        touched.advisoryType &&
                        errors.advisoryType}
                    </span>
                  </Col>
                ) : null}
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <FormDatePicker
                    className="formInput"
                    style={{ width: "100%" }}
                    advisoryType={values.advisoryType}
                    showTime
                    onChange={(value, dateString) => {
                      return setFieldValue(
                        "validTill",
                        value.toDate().getTime()
                      );
                    }}
                    enableCustomDate={enableCustomDate}
                    setFieldValue={setFieldValue}
                    validTill={props.validTill}
                  />
                </Col>
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <label>Comments</label>
                  <Input.TextArea
                    className="formInput"
                    name="comments"
                    placeholder="Comments"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.comments}
                  />
                  <span style={errorStyle}>
                    {errors.comments && touched.comments && errors.comments}
                  </span>
                </Col>
                <Col span={24} style={{ marginTop: 15 }}>
                  <ConfirmationPopup
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    values={values}
                    errors={errors}
                    touched={touched}
                    title="Add Advise"
                  />
                </Col>
              </Row>
            </form>
          )}
        </Formik>
      </div>
    </section>
  );
};
export default withRouter(AddAdvise);
